package pl.finn.forms.utils.model

object Util {
  val rozszerzeniaZalacznikow = setOf(
    "7z", "avi", "CAdES", "css", "csv", "dgn", "doc",
    "docx", "dwf", "dwg", "dxf", "geotiff", "gif", "gml", "gz", "gzip", "html",
    "jp2", "jpeg", "jpg", "m4a", "mp3", "mp4", "mpeg", "mpeg4", "mpg", "odp", "ods",
    "odt", "ogg", "ogv", "ott", "PAdES", "pdf", "png", "ppt", "pptx", "rng", "rtf",
    "svg", "tar", "tif", "tiff", "tls", "txt", "wav", "XAdES", "xhtml", "xls",
    "xlsx", "xml", "XMLenc", "XMLsig", "xps", "xsd", "xsl", "xslt", "zip"
  )

  fun getRandomString(): String {
    val allowedChars = ('a'..'z') + ('A'..'Z')
    return (1..8)
      .map { allowedChars.random() }
      .joinToString("")
  }

  fun parseAmount(amount: Double): String {
    var parts=amount.toString().split(".")
    return parts[0].reversed().chunked(3).joinToString(" ").reversed() + (if(parts.size > 1) "," + parts[1] else "")
  }

  fun parseAmount(amount: String): String {
    var parts=amount.split(".")
    return parts[0].reversed().chunked(3).joinToString(" ").reversed() + (if(parts.size > 1) "," + parts[1] else "")
  }
}